import { startOfDay, startOfMonth } from "date-fns";

import { getWeekStart } from "@app/util/dates";

import {
  dayGranularityDateFormatter,
  minusDays,
  monthGranularityDateFormatter,
  SimpleRangeType,
  weekGranularityDateFormatter,
} from "./dateUtils";

const SIMPLE_DATE_RANGE: SimpleRangeType[] = [
  {
    dateFormatter: dayGranularityDateFormatter,
    dateRounder: startOfDay,
    getStartDate: minusDays(7),
    granularity: "day",
    label: "Last 7 Days",
  },
  {
    dateFormatter: weekGranularityDateFormatter,
    dateRounder: getWeekStart,
    getStartDate: minusDays(30),
    granularity: "week",
    label: "Last 30 Days",
  },
  {
    dateFormatter: monthGranularityDateFormatter,
    dateRounder: startOfMonth,
    getStartDate: minusDays(90),
    granularity: "month",
    label: "Last 90 Days",
  },
];

export default SIMPLE_DATE_RANGE;
